<template>
  <el-container direction="vertical" style="height: auto" id="insureConfirm">
    <el-row class="row-bg">
      <!-- 头部 -->
      <el-header>
        <el-col :span="24" style="text-align: center">
          <div>
            <span class="p-title">{{allData.dynamicValidateForm.projectName}}</span>
          </div>
        </el-col>
        <el-col :span="14" :push="5" class="my-step">
          <el-steps :active="1" align-center>
            <el-step title="选择投保方案"></el-step>
            <el-step title="填写投保信息"></el-step>
            <el-step title="在线支付"></el-step>
            <el-step title="完成投保"></el-step>
          </el-steps>
        </el-col>
      </el-header>
    </el-row>
    <el-main>
      <!-- 表单计划 -->
      <el-row>
        <el-col :span="16" :push="4">
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title userInfo"><div class="header">基础信息</div></div>
              <el-form-item class="form-item-label" label="方案名称">
                <div>{{allData.dynamicValidateForm.projectName}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="保险期限">
                <div>自 {{$$.dateFormat(allData.beInsuredEffectiveDate)}} 起至
                  {{$$.dateAddDays($$.dateAddDays($$.dateFormat(allData.beInsuredEffectiveDate),'12个月'),'-1天')}} 止
                </div>
              </el-form-item>
              <el-form-item class="form-item-label" label="订单状态">
                <div>待确认</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="订单人数">
                <div>{{groupSize}}人</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="保费">
                <div>{{discountPremium}}元</div>
              </el-form-item>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title userInfo"><div class="header">保障项目</div></div>
              <el-table
                :data="allData.dynamicValidateForm.cards"
                border
                style="width: 100%">
                <el-table-column
                  type="index"
                  label="保险计划"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="occThreeName"
                  label="职业类别">
                </el-table-column>
                <el-table-column
                  prop="groupSize"
                  label="投保人数">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" width="1">
                  <template slot-scope="scope">
                    <el-table-column v-if="k !== 'elm' && k !== 'isRootInsert'" v-for="(v, k) in scope.row.skuSpecNameList" :label="k" :key="k" >{{v}}</el-table-column>
                    <!--<el-button size="mini" @click="onSee(scope.row)">查看</el-button>
                    <el-button size="mini" @click="onDelete(scope.row)"
                               v-if="('等待确认,待支付'.indexOf(scope.row.orderStatus.toString()) >= 0)">取消
                    </el-button>
                    <el-button size="mini" @click="onPay(scope.row)" v-if="scope.row.orderStatus === '待支付'">立刻支付</el-button>-->
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title supportPlan"><div class="header">投保人信息</div></div>
              <el-form-item class="form-item-label" label="投保单位">
                <div>{{allData.dynamicValidateForm.companyName}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="具体地址">
                <div>{{allData.submitOrderData.companyAddress}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="社会统一信用代码">
                <div>{{allData.socialCreditCode}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="联系人姓名">
                <div>{{allData.legalPerson}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="联系人手机号码">
                <div>{{allData.mobile}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="联系人邮箱">
                <div>{{allData.workEmail}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="联系人地址">
                <div>{{allData.address}}</div>
              </el-form-item>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title supportPlan"><div class="header">被保人信息</div></div>
              <el-table
                :data="allData.beInsureTableData"
                border
                max-height="500"
                class="my-el-table">
                <el-table-column
                  align="center"
                  prop="index"
                  type="index"
                  label="序号"
                  width="50">
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="beInsureName"
                  label="姓名">
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="beInsureIdType"
                  label="证件类型"
                  width="80">
                  <template slot-scope="scope">
                    <div v-if="scope.row.beInsureIdType === 1">身份证</div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="beInsureIdCard"
                  label="证件号码"
                  width="182">
                  <template slot-scope="scope">
                    <div style="text-align: center">
                      <p style="margin-top:0;margin-bottom:0">{{scope.row.beInsureIdCard}}</p>
                      <p v-if="scope.row.idCardErrorMsg !== ''" style="margin-top:0;margin-bottom:0;color: #FF7052">
                        {{scope.row.idCardErrorMsg}}</p>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="beSex"
                  label="性别"
                  width="55">
                  <template slot-scope="scope">
                    <div v-if="scope.row.beSex === 'M'">男性</div>
                    <div v-if="scope.row.beSex === 'F'">女性</div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="beBirthday"
                  label="出生日期"
                  value-format="yyyy-MM-dd"
                  width="101">
                  <template slot-scope="scope">
                    <div style="text-align: center">
                      <p style="margin-top:0;margin-bottom:0">{{scope.row.beBirthday.replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3")}}</p>
                      <p v-if="scope.row.ageErrorMsg !== ''" style="margin-top:0;margin-bottom:0;color: #FF7052">
                        {{scope.row.ageErrorMsg}}</p>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="bePlan"
                  label="保障计划"
                  width="90">
                  <template slot-scope="scope">
                    <div style="text-align: center">
                      <p style="margin-top:0;margin-bottom:0">{{scope.row.bePlan}}</p>
                      <p v-if="scope.row.planErrorMsg !== ''" style="margin-top:0;margin-bottom:0;color: #FF7052">
                        {{scope.row.planErrorMsg}}</p>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="realityOccCode"
                  label="职业代码"
                  width="102">
                  <template slot-scope="scope">
                    <div style="text-align: center">
                      <p style="margin-top:0;margin-bottom:0">{{scope.row.realityOccCode}}</p>
                      <p v-if="scope.row.codeErrorMsg !== ''" style="margin-top:0;margin-bottom:0;color: #FF7052">
                        {{scope.row.codeErrorMsg}}</p>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </el-card>
          <el-card class="box-card" v-if="allData.needInvoices">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title userInfo"><div class="header">发票信息</div></div>
              <el-form-item class="form-item-label" label="发票类型">
                <div>{{allData.receiptType === 2 ?"普通发票（电子发票）" :"增值税专用发票（纸质发票）"}}</div>
              </el-form-item>
              <span v-if="allData.receiptType === 2">
                <el-form-item class="form-item-label" label="发票抬头">
                  <div>{{allData.dynamicValidateForm.companyName}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="纳税人识别号">
                  <div>{{allData.idType === 6 ? allData.socialCreditCode :allData.orderMailInvoiceInfo.tIN}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人姓名">
                  <div>{{allData.orderMailInvoiceInfo.rName}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人手机号">
                  <div>{{allData.orderMailInvoiceInfo.rPhone}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人邮箱">
                  <div>{{allData.orderMailInvoiceInfo.rMail}}</div>
                </el-form-item>
              </span>
              <span v-else>
                <el-form-item class="form-item-label" label="发票抬头">
                  <div>{{allData.dynamicValidateForm.companyName}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="纳税人识别号">
                  <div>{{allData.idType === 6 ? allData.socialCreditCode :allData.orderMailInvoiceInfo.tIN}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="税务登记地址">
                  <div>{{allData.orderMailInvoiceInfo.tRA}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="税务登记电话">
                  <div>{{allData.orderMailInvoiceInfo.tRT}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="开户银行">
                  <div>{{allData.orderMailInvoiceInfo.openBank}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="银行账户">
                  <div>{{allData.orderMailInvoiceInfo.bankNum}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人姓名">
                  <div>{{allData.orderMailInvoiceInfo.rName}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人手机号">
                  <div>{{allData.orderMailInvoiceInfo.rPhone}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人地址">
                  <el-select @change="rProvinceChange" v-model="allData.orderMailInvoiceInfo.rProvinceId"
                             placeholder="请选择"
                             class="form-item-input my-input" :disabled="true">
                  <el-option
                    v-for="item in allData.chinaArea"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select @change="rCityChange" v-model="allData.orderMailInvoiceInfo.rCityId" placeholder="请选择"
                           class="form-item-input my-input" :disabled="true">
                  <el-option
                    v-for="item in allData.orderMailInvoiceInfo.rCityList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="allData.orderMailInvoiceInfo.rAreaId" placeholder="请选择"
                           class="form-item-input my-input" :disabled="true">
                  <el-option
                    v-for="item in allData.orderMailInvoiceInfo.rAreaList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="具体地址" class="form-item-label">
                  <el-input class="form-item-input my-input-left " style="max-width: 640px;"
                            v-model="allData.orderMailInvoiceInfo.rAddress"
                            placeholder="请输入具体地址" :disabled="true"
                  ></el-input>
                </el-form-item>
              </span>
            </el-form>
          </el-card>
          <el-card class="box-card" v-else>
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title userInfo"><div class="header">发票信息</div></div>
              <el-form-item class="form-item-label" label="发票类型">
                <div>无发票</div>
              </el-form-item>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title supportPlan"><div class="header">受益人信息</div></div>
              <el-form-item class="form-item-label" label="受益人">
                <div>法定受益人</div>
              </el-form-item>
            </el-form>
          </el-card>
          <el-row style="margin: 0 auto;padding: 20px 0 50px" class="space-around">
            <el-button type="danger" @click="backInsureDetails" round class="backInsureDetails">返回修改
            </el-button>
            <el-button type="danger" @click="submitOrder" round class="submitOrder">提交订单
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
  export default {
    name: "insureConfirm",
    data() {
      return {
        allData: {
          dynamicValidateForm: {
            cards: [{
              groupSize: '',
              occId: '',
              realityOccCode: '',
              //-- 职业参数
              occOneId: '',
              occTwoList: [],
              occTwoId: '',
              occThreeList: [],
              occThreeId: '',
              occOneName: '',
              occTwoName: '',
              occThreeName: '',
              //职业id
              occupationId: 0,
              //职业类别
              azcnCode: 0,
              //取值获取规格值下拉选项
              pid: 0,
              topLevelId: 0,
              skuInfo: {},
            }],
            companyName: '',
            guaranteePeriod: "12个月",
            insuranceAge: "18-65周岁",
            occupationType: "1-5类",
            occOneList: [],
            projectName: '',
            //-- sku参数
            skuList: [],
            skuSpecList: [],
            skuRelationAddList: [],
            occupationList: [],
          },
          orderMailInvoiceInfo: {
            tIN: '', // 纳税人识别号
            rName: '', // 收件人姓名
            rPhone: '', // 收件人手机号
            rMail: '', // 收件人邮箱
            tRA: '', // 税务登记地址
            tRT: '', // 税务登记电话
            openBank: '', // 开户银行
            bankNum: '', // 银行账户
            rCityId: '', // 	城市ID
            rProvinceId: '', // 	省份ID
            rAreaId: '', // 	地区ID
            rAddress: '', // 收件人具体地址
            rCityList: [],
            rAreaList: []
          },
          addBeInsureData: {
            addBeInsureName: '',     // 被保人姓名
            addRealityOccCode: '',  // 被保人职业代码
            addBeBirthday: '',     // 被保人出生日期
            addBeSex: '',          // 被保人性别
            addBeInsureIdCard: '',  // 被保人证件号
            addBeInsureIdType: '', // 被保人证件类型
            bePlan: '' // 被保人对应计划
          },
          // -- 被保人列表
          beInsureTableData: [],
          cityId: '', // 	城市ID
          provinceId: '', // 	省份ID
          areaId: '', // 	地区ID
          cityName: '', // 	城市名称
          provinceName: '', // 	省份名称
          areaName: '', // 地区名称
          socialCreditCode: '', // 证件号码
          address: '', // 联系人具体地址
          specificAddress: '', // 公司具体地址
          mobile: '',// 联系人手机号
          legalPerson: '', // 联系人
          workEmail: '', // 联系人邮箱
          cityList: [],
          areaList: [],
          beInsuredEffectiveDate: '',// 起保日期
          needInvoices: false,
          receiptType: 2,
          chinaArea: this.chinaLifeAccidentDistrict.chinaAreaList(),
          idType: '',
          addDialogVisible: false, // 添加被保人按钮弹出框
          requestToken: '',
          submitOrderData: {},
        },
        groupSize: '',
        discountPremium: ''
      }
    },
    methods: {
      // -- 省份改变事件
      rProvinceChange() {
        this.$forceUpdate();
        this.allData.chinaArea.forEach(item => {
          item.value === this.allData.orderMailInvoiceInfo.rProvinceId ? this.allData.orderMailInvoiceInfo.rCityList = item.children : [];
        });
        this.allData.orderMailInvoiceInfo.rCityId = '';
        this.allData.orderMailInvoiceInfo.rAreaId = '';
      },
      // -- 城市改变事件
      rCityChange() {
        this.$forceUpdate();
        this.allData.orderMailInvoiceInfo.rCityList.forEach(item => {
          item.value === this.allData.orderMailInvoiceInfo.rCityId ? this.allData.orderMailInvoiceInfo.rAreaList = item.children : [];
        });
        this.allData.orderMailInvoiceInfo.rAreaId = '';
      },
      // -- 从上个页面获取数据进行拼装适应页面
      backInsureDetails() {
        sessionStorage.setItem('allData', JSON.stringify(this.allData));
        this.$router.push({name: 'insureDetails', query:{productId: this.$route.query.productId, planId: this.$route.query.planId}});
      },
      premiumCount() {
        let loadingInstance = this.Loading.service({fullscreen: true});
        this.axios.post('/management/quotemaininfo/premiumCount', this.allData.submitOrderData).then((response) => {
          let data = response.data;
          if (data.success) {
            this.discountPremium = data.discountPremium;
          } else {
            this.$message.error(data.msg);
          }
        });
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
      },
      // -- 数据校验
      dataIsValid() {
        let isValid = true;
        let reg = /^\d+$/;
        let idTypeSixReg = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/; // 统一社会信用代码正则校验
        let idTypeElevenRge = /[0-9A-HJ-NPQRTUWXY]{9}/; // 组织机构代码正则校验
        let PHONE_REGEX = /^1(3[0-9]|4[57]|5[0-35-9]|7[0135678]|8[0-9])\d{8}$/;  // 手机号正则校验
        let EMAIL_REGEX = /^([a-zA-Z0-9_\.\-])+[\@,\＠](([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;  // 邮箱正则校验
        let TELEPHONE_REGEX = /^\d{3}-\d{8}|\d{4}-\d{7}$/; // 固定电话校验
        let BANK_NUM_REG = /^[0-9]{1,20}$/; // 银行账户校验
        if (!this.allData.dynamicValidateForm.companyName.trim()) {
          this.$message.error("投保单位不能为空!");
          return isValid = false;
        }
        try {
          this.allData.dynamicValidateForm.cards.forEach((item, index) => {
            if (!this.$$.isValidObj(item.groupSize) || item.groupSize <= 0) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的投保人数不能为空!");
            }
            if (!reg.test(item.groupSize)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的投保人数只能填写数字!");
            }
            if (!this.$$.isValidObj(item.occId)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的职业不能为空!");
            }
            if (!this.$$.isValidObj(item.realityOccCode)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的职业代码不能为空!");
            }
            if (!this.$$.isValidObj(item.azcnCode)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的职业类别不能为空!");
            }
            if (!this.$$.isValidObj(item.skuInfo.id)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的保障项目不能为空!");
            }
            this.allData.dynamicValidateForm.cards.forEach((j,i) => {
              if (i !== index && item.hurtValue === j.hurtValue && item.occThreeId === j.occThreeId
                && item.medicalValue === j.medicalValue && item.allowanceValue === j.allowanceValue
              ) {
                throw new Error("存在职业和保障项目相同的计划,请重试!");
              }
            });
          });
        } catch (e) {
          this.$message.error(e.message);

        }

        // -- 投保数据校验
        if (!this.$$.isValidObj(this.allData.beInsuredEffectiveDate)) {
          this.$message.error("请选择起保日期!");
          return isValid = false;
        }
        /*if (this.$$.dateDifference(this.allData.beInsuredEffectiveDate) < 2) {
          this.$message.error("起投日期必须为三天后!");
          return isValid = false;
        }*/
        if (!this.$$.isValidObj(this.allData.areaId)) {
          this.$message.error("请选择投保地区!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.allData.specificAddress)) {
          this.$message.error("请填写投保具体地址!");
          return isValid = false;
        }
        if (this.allData.specificAddress.replace(/[^\u0000-\u00ff]/g, "aa").length > 100) {
          this.$message.error("具体地址最多为50个汉字,请重新输入!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.allData.idType)) {
          this.$message.error("请选择证件类型!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.allData.socialCreditCode)) {
          this.$message.error("请输入证件号码!");
          return isValid = false;
        }
        if (this.allData.idType === 6 && idTypeSixReg.test(this.allData.socialCreditCode) === false) {
          this.$message.error("统一社会信用代码格式不合法！");
          return isValid = false;
        }
        if (this.allData.idType === 11 && idTypeElevenRge.test(this.allData.socialCreditCode) === false) {
          this.$message.error("组织机构代码证格式不合法！");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.allData.legalPerson)) {
          this.$message.error("请输入联系人姓名!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.allData.mobile)) {
          this.$message.error("请输入联系人手机号!");
          return isValid = false;
        }
        if (PHONE_REGEX.test(this.allData.mobile) === false) {
          this.$message.error("联系人手机号错误,请重新输入!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.allData.address)) {
          this.$message.error("请输入联系人地址!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.allData.workEmail)) {
          this.$message.error("请输入联系人邮箱!");
          return isValid = false;
        }
        if (EMAIL_REGEX.test(this.allData.workEmail) === false) {
          this.$message.error("联系人邮箱错误,请重新输入!");
          return isValid = false;
        }
        // -- 被保人数据校验
        if (this.$$.isEmptyObject(this.allData.beInsureTableData)) {
          this.$message.error("被保人为空,请上传被保人!");
          return isValid = false;
        }
        // -- 检查被保人列表是否有错误信息
        try {
          this.allData.beInsureTableData.forEach((item, index) => {
            if (this.$$.isValidObj(item.ageErrorMsg) || this.$$.isValidObj(item.codeErrorMsg) || this.$$.isValidObj(item.planErrorMsg)){
              throw new Error("序号:" + (index + 1) + "存在错误信息,请删除!");
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return isValid = false;
        }
        if (this.allData.needInvoices) {
          if (this.allData.idType !== 6 && !this.$$.isValidObj(this.allData.orderMailInvoiceInfo.tIN)) {
            this.$message.error("请输入发票纳税人识别号!");
            return isValid = false;
          }
          if (this.allData.idType !== 6 && !idTypeSixReg.test(this.allData.orderMailInvoiceInfo.tIN)) {
            this.$message.error("纳税人识别号错误,请重新输入!");
            return isValid = false;
          }
          if (!this.$$.isValidObj(this.allData.orderMailInvoiceInfo.rName)) {
            this.$message.error("请输入收件人姓名!");
            return isValid = false;
          }
          if (!this.$$.isValidObj(this.allData.orderMailInvoiceInfo.rPhone)) {
            this.$message.error("请输入收件人手机号!");
            return isValid = false;
          }
          if (PHONE_REGEX.test(this.allData.orderMailInvoiceInfo.rPhone) === false) {
            this.$message.error("收件人手机号错误,请重新输入!");
            return isValid = false;
          }
          // 2 电子发票 1 纸质发票
          if (this.allData.receiptType === 2) {
            if (!this.$$.isValidObj(this.allData.orderMailInvoiceInfo.rMail)) {
              this.$message.error("请输入收件人邮箱!");
              return isValid = false;
            }
            if (EMAIL_REGEX.test(this.allData.orderMailInvoiceInfo.rMail) === false) {
              this.$message.error("收件人邮箱错误,请重新输入!");
              return isValid = false;
            }
          } else {
            if (!this.$$.isValidObj(this.allData.orderMailInvoiceInfo.tRA)) {
              this.$message.error("请输入税务登记地址!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.allData.orderMailInvoiceInfo.tRA)) {
              this.$message.error("请输入税务登记地址!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.allData.orderMailInvoiceInfo.tRT)) {
              this.$message.error("请输入税务登记电话!");
              return isValid = false;
            }
            if (TELEPHONE_REGEX.test(this.allData.orderMailInvoiceInfo.tRT) === false) {
              this.$message.error("税务登记电话错误,请重新输入!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.allData.orderMailInvoiceInfo.tRT)) {
              this.$message.error("请输入税务登记电话!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.allData.orderMailInvoiceInfo.openBank)) {
              this.$message.error("请输入开户银行!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.allData.orderMailInvoiceInfo.bankNum)) {
              this.$message.error("请输入银行账户!");
              return isValid = false;
            }
            if (!this.$$.bankCardVerification(this.allData.orderMailInvoiceInfo.bankNum)){
              this.$message.error("银行账户错误,请重新输入!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.allData.orderMailInvoiceInfo.rAreaId)) {
              this.$message.error("请选择收件人地址!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.allData.orderMailInvoiceInfo.rAddress)) {
              this.$message.error("请输入收件人具体地址!");
              return isValid = false;
            }
          }
        }
        return isValid;
      },
      // -- 订单提交
      submitOrder() {
        if (!this.dataIsValid()) {
          return;
        }
        let loadingInstance = this.Loading.service({fullscreen: true});
        this.axios.post('/management/mobileBusinessInsurance/createOrderPc?sellProductId=' + this.allData.submitOrderData.sellProductId + "&requestToken=" + encodeURIComponent(decodeURIComponent(this.allData.submitOrderData.requestToken)),
          this.allData.submitOrderData
        ).then((response) => {
          let data = response.data;
          if (data.success) {
            let orderPaymentParams = {
              orderToken: data.datas.orderToken,
              sellProductName: data.datas.sellProductName,
            };
            sessionStorage.setItem('orderPaymentParams', JSON.stringify(orderPaymentParams));
            this.$router.push({name: 'orderPaymentType'});
          } else {
            this.$message.error(data.msg);
          }
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        });
      }
    },
    mounted() {
      let allData = sessionStorage.getItem('allData');

      if (this.$$.isValidObj(allData)) {
        this.allData = JSON.parse(allData);
        let groupSize = 0;

        this.allData.dynamicValidateForm.cards.forEach(item => {
          groupSize += parseInt(item.groupSize);
        });
        this.groupSize = groupSize;
        this.premiumCount();
      } else {
        this.$confirm('当前订单参数错误，请重新进入~', '温馨提示：', {
          showClose: false,
          closeOnClickModal: false,
          center: true,
          showCancelButton: false,
          confirmButtonText: '确认',
        }).then(() => {
          this.$router.push({name: 'quotationManagement'});
        });
      }

    }
  }
</script>

<style scoped>

  .box-card {
    width: auto;
    height: auto;
    padding: 20px;
    margin-bottom: 2.5rem;
  }

  /deep/ .box-card-div{
    position: relative;
  }

  .box-card-div-title {
    height: 12px;
    background: #FFBF00;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
    display: inline-block;
    position: relative;
  }

  .box-card-div-title>.header{
    text-align: center;
    position: absolute;
    left: 0;
    top: -20px;
  }

  .box-card-div>span{
    position: absolute;
    right: 0;
    top: -20px;
  }

  .box-card-div-title.userInfo{
    width: 96px;
  }

  .supportPlan{
    width: 120px;
  }

  .p-title {
    font-size: 2.5rem;
    color: #333333;
    font-weight: bold;
    font-style: italic;
  }

  .row-bg {
    padding: 60px 0 40px;
  }

  .form-item-label {
    font-size: 1rem;
    font-weight: 500;
    color: #333333;
    margin: 0 auto;
  }

  .form-item-label div {
    font-size: 1rem;
    font-weight: 400;
    color: #333333;
    padding: 0 10px;
    margin: 0 5px 5px 10px;
    background-color: #F7F7F7;
  }

  .form-item-label /deep/ .el-form-item__label {
    font-size: 1rem !important;
  }

  .backInsureDetails{
    width: 15rem;
    max-width: 240px;
    font-size: 1rem;
    background: #CCCCCC;
    border-color: #CCCCCC;
    border-radius: 12px;
  }

  .submitOrder{
    width: 15rem;
    max-width: 240px;
    font-size: 1rem;
    background: #FF7052;
    border-radius: 12px;
  }

  .my-step {
    padding-top: 63px;
  }

  /* 已完成title文字颜色 */
  .my-step /deep/ .is-finish {
    font-size: 1rem;
    font-weight: 500;
    font-style: italic;
    color: #FF7052;
  }

  /* 进行中title文字颜色 */
  .my-step /deep/ .is-process {
    font-size: 1rem;
    font-weight: 500;
    font-style: italic;
    color: #FF7052;
  }

  /* 等待中title文字颜色*/
  .my-step /deep/ .is-wait {
    font-size: 1rem;
    font-weight: 500;
    font-style: italic;
    color: #666666;
  }

  /* 圆圈数字颜色*/
  .my-step /deep/ .el-step__icon-inner {
    padding-right: 6px;
    font-size: 1.5rem;
    font-style: italic !important;
    font-weight: 800;
    color: #FFFFFF;
  }

  /* 圆圈数字颜色*/
  .my-step /deep/ .el-step__icon-inner:before {
    content: '0';
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-finish .is-text {
    background: #EB6F67 !important;
    border-color: #EB6F67 !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-process .is-text {
    background: #EB6F67 !important;
    border-color: #EB6F67 !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-wait .is-text {
    background: #CCCCCC !important;
    border-color: #CCCCCC !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-finish 圆圈颜色*/
  .my-step /deep/ .el-steps.el-steps--horizontal {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;

  }

  .my-step /deep/ .el-step.is-horizontal.is-center {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;
  }

  .my-step /deep/ .el-step__head.is-finish {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;
  }

  /*is-process 圆圈颜色*/
  .my-step /deep/ .el-steps.el-steps--horizontal {
    color: #FF7052;
    border-color: #FF7052;
  }

  .my-step /deep/ .el-step__head.is-process {
    color: #FF7052;
    border-color: #FF7052;
  }

  .my-step /deep/ .el-step.is-horizontal.is-center {
    color: #FF7052;
    border-color: #FF7052;
  }

  /* 输入框去圆角 */
  .my-input /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 1rem;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
  }

  /* 输入框文字左对齐 */
  .my-input-left /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: left !important;
    padding: 0;
  }

  /* 必填框去掉*号 */
  .form-item-label /deep/ .el-form-item__label:before {
    color: #FFFFFF !important;
  }

  .form-item-label /deep/ .el-form-item__label {
    font-size: 1rem !important;
    margin: 0 auto;
  }

  /* 必填框去掉*号 */
  .form-item-label-big /deep/ .el-form-item__label:before {
    color: #FFFFFF !important;
  }

  .form-item-label-big /deep/ .el-form-item__label {
    font-size: 1.25rem !important;
    font-weight: bold;
    width: 160px !important;
  }

  /* 必填框去掉*号 */
  .form-item-label-add /deep/ .el-form-item__label:before {
    color: #FFFFFF !important;
  }

  .form-item-label-add /deep/ .el-form-item__label {
    font-size: 16px !important;
    width: 100px !important;
    text-align: right !important;
    padding-right: 25px !important;
  }

  .underwriterDetailed /deep/ .el-form-item__content{
    padding-left: 10px;
  }

  .el-dialog__wrapper /deep/ .el-form-item__content{
    margin-left: 100px!important;
  }

  /* 取出radio圆角 */
  .my-button .el-radio-button:first-child /deep/ .el-radio-button__inner {

  }

  /* 选择项的颜色 */
  .is-active /deep/ .el-radio-button__inner {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    background-color: #FFEEEB !important;
    color: #FF7052 !important;
    border: 1px solid #FF7052 !important;
  }

  .my-button /deep/ .el-radio-button__inner {
    box-shadow: 0 0 0 0 !important;
    -webkit-box-shadow: 0 0 0 0 !important;
    border: 0;
    border-radius: 0 !important;
    background-color: #F7F7F7;
    color: #333333;
  }

  .el-radio-button:first-child /deep/ .el-radio-button__inner {
    border-left: 0;
  }

  .is-active /deep/ .el-radio-button__inner:hover {
    color: #FF7052 !important;
  }

  .my-button /deep/ .el-radio-button__inner:hover {
    color: #333333;
  }

  .el-input--prefix /deep/ .el-input__inner {
    text-align: center;
    background-color: #F7F7F7;
    border: 0;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    padding: 0 30px 0 10px;
  }

  /deep/ .el-dialog--center {
    box-shadow: 0 12px 28px 0 rgba(204, 204, 204, 0.25) !important;
    border-radius: 16px !important;
  }

  .el-dialog--center /deep/ .el-dialog__body {
    text-align: center !important;
    padding: 15px 25px 10px;
  }

  .dialog-footer{
    margin: 20px auto;
  }

  /* 新增被保人输入框去圆角 */
  .my-input-add /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
    padding: 0 30px 0 10px;
  }

  /deep/ .el-dialog__title {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
  }

  /deep/ .el-dialog__header {
    padding: 40px 20px 0;
  }

  .el-dialog__headerbtn /deep/ .el-dialog__close{
    font-weight: bold;
    font-size: 2rem;
  }

  .el-table /deep/ .cell {
    text-align: center;
  }

  .el-table th{
    background: #EBEBEB!important;
    border-bottom: 1px solid #CCCCCC!important;
    border-right: 1px solid #CCCCCC!important;
  }

  .el-table th /deep/ .cell{
    display: block;
  }

  .box-card /deep/ .is-leaf {
    background: #f0f0f0;
    text-align: center;
  }

  .form-item-label.special /deep/ .el-form-item__label {
    padding: 0 30px 0 0;
  }

  .specialTip{
    width: 1rem;
    height: 1rem;
    padding: 0;
    border-radius: 50%;
    border: 1px solid #F2613F;
    display: inline-block;
    text-align: center;
    font-size: .75rem;
    line-height: 10px;
    position: absolute;
    top: calc((40px - 1rem)/2);
    left: -25px;
  }
  .specialTip:before {
    width: 1rem;
    height: 1rem;
    content: '?';
    font-weight: bold;
    color: #F2613F;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/insureConfirm.vue